import { EFacilityType, NonEmptyArray } from '../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectLivingConditionsFilter } from 'shared/selectors/advancedFilters';

export const LivingConditionsContainer: FC = () => {
  const { label, value, options } = useSelector(selectLivingConditionsFilter);

  const onChange = useFilterChangeCallback();

  const handleLivingConditionsChange = useCallback(
    (newValue: NonEmptyArray<EFacilityType> | null) => {
      onChange({ action: 'setLivingConditions', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleLivingConditionsChange} />
    </AdvancedFilterRow>
  );
};
